import { render, staticRenderFns } from "./CardWaitingConfirmation.vue?vue&type=template&id=52d461d6&scoped=true"
import script from "./CardWaitingConfirmation.vue?vue&type=script&lang=js"
export * from "./CardWaitingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./CardWaitingConfirmation.vue?vue&type=style&index=0&id=52d461d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d461d6",
  null
  
)

export default component.exports